import React, {useEffect, useState} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import Modal from 'react-native-modal';
import {observer} from 'mobx-react-lite';

import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import Button from '../themed/Button';
import TextInput from '../ui-controls/form/TextInput';
import Text from '../ui-controls/Text';

const CouponModal = observer(
  ({open, callback}: {open: boolean; callback?: () => void}) => {
    const {cartStore} = useStores();
    const [visible, setVisible] = useState(false);
    const [coupon, setCoupon] = useState(
      cartStore.currentOrder?.coupon_code || null,
    );

    useEffect(() => {
      setCoupon(cartStore.currentOrder?.coupon_code);
    }, [
      cartStore,
      cartStore.currentOrder,
      cartStore.currentOrder?.coupon_code,
    ]);

    const onClose = () => {
      if (callback) {
        callback();
      }
      setVisible(false);
    };

    useEffect(() => {
      setVisible(open);
    }, [open, visible]);

    const applyCoupon = () => {
      cartStore.updateCoupon(coupon);
      onClose();
    };

    return (
      <Modal
        onBackdropPress={() => onClose()}
        isVisible={visible}
        style={styles.main}
        hasBackdrop
        backdropColor="black"
        backdropOpacity={0.5}>
        <View style={styles.modal}>
          <Text style={styles.title}>Add coupon code</Text>
          <View style={styles.border} />
          <TextInput
            style={styles.textInput}
            onChangeText={v => setCoupon(v)}
            value={coupon}
            autoCapitalize="characters"
          />
          <View style={styles.actions}>
            <Button
              title={
                coupon !== cartStore.currentOrder?.coupon_code &&
                cartStore.currentOrder?.coupon_code
                  ? 'CHANGE COUPON'
                  : 'ADD COUPON'
              }
              onPress={() => applyCoupon()}
            />
            {cartStore.currentOrder?.coupon_code ? (
              <Button
                title="REMOVE COUPON"
                onPress={() => {
                  setCoupon(null);
                  cartStore.updateCoupon(null);
                  onClose();
                }}
                variant="outlined"
              />
            ) : null}
          </View>
        </View>
      </Modal>
    );
  },
);

export default CouponModal;

const styles = StyleSheet.create({
  main: {
    alignItems: 'center',
  },
  modal: {
    backgroundColor: 'white',
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'grey',
    width: '80%',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
  },
  border: {},
  textInput: {
    marginTop: 16,
    marginBottom: 18,
  },
  actions: {
    flexDirection: 'column',
    gap: 8,
  },
});
